/**
 * @generated SignedSource<<99f5ec68ea791d72bc56377355ca02f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type PreviewWidgetTaskCollectionInput = {
  id: string;
  tasks: ReadonlyArray<PreviewWidgetTaskCollectionTaskInput>;
};
export type PreviewWidgetTaskCollectionTaskInput = {
  id: string;
  ordinal: number;
  sectionId: string;
};
export type WidgetTaskCollectionMockPreviewQuery$variables = {
  input: PreviewWidgetTaskCollectionInput;
  storecastId: string;
};
export type WidgetTaskCollectionMockPreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetTaskCollection: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskCollection_widgetTaskCollection">;
    };
  };
};
export type WidgetTaskCollectionMockPreviewQuery$rawResponse = {
  readonly dashboard: {
    readonly id: string;
    readonly previewWidgetTaskCollection: {
      readonly id: string;
      readonly taskSections: ReadonlyArray<{
        readonly __typename: string;
        readonly id: string;
        readonly inProgressTaskExecution: {
          readonly __typename: "TaskExecutionCheck";
          readonly __isTaskExecution: "TaskExecutionCheck";
          readonly checkValue: TaskSentiment | null;
          readonly id: string;
          readonly routineOccasion: {
            readonly endAt: string;
            readonly id: string;
          };
        } | {
          readonly __typename: "TaskExecutionNumber";
          readonly __isTaskExecution: "TaskExecutionNumber";
          readonly formattedNumberValue: string | null;
          readonly id: string;
          readonly numberValue: number | null;
          readonly routineOccasion: {
            readonly endAt: string;
            readonly id: string;
          };
        } | {
          readonly __typename: "TaskExecutionText";
          readonly __isTaskExecution: "TaskExecutionText";
          readonly id: string;
          readonly routineOccasion: {
            readonly endAt: string;
            readonly id: string;
          };
          readonly textValue: string | null;
        } | {
          readonly __typename: string;
          readonly __isTaskExecution: string;
          readonly id: string;
          readonly routineOccasion: {
            readonly endAt: string;
            readonly id: string;
          };
        } | null;
        readonly section: {
          readonly id: string;
          readonly title: string | null;
        };
        readonly task: {
          readonly __typename: string;
          readonly id: string;
          readonly routine: {
            readonly id: string;
            readonly title: string;
          };
          readonly title: string;
        };
      }>;
      readonly title: string;
    };
  } | null;
};
export type WidgetTaskCollectionMockPreviewQuery = {
  rawResponse: WidgetTaskCollectionMockPreviewQuery$rawResponse;
  response: WidgetTaskCollectionMockPreviewQuery$data;
  variables: WidgetTaskCollectionMockPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTaskCollectionMockPreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "WidgetTaskCollection",
                "kind": "LinkedField",
                "name": "previewWidgetTaskCollection",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WidgetTaskCollection_widgetTaskCollection"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetTaskCollectionMockPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "WidgetTaskCollection",
            "kind": "LinkedField",
            "name": "previewWidgetTaskCollection",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "taskSections",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "routine",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "inProgressTaskExecution",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isTaskExecution"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "routineOccasion",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endAt",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "checkValue",
                            "storageKey": null
                          }
                        ],
                        "type": "TaskExecutionCheck",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numberValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formattedNumberValue",
                            "storageKey": null
                          }
                        ],
                        "type": "TaskExecutionNumber",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textValue",
                            "storageKey": null
                          }
                        ],
                        "type": "TaskExecutionText",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9e75bc47eb26d3b9b7179654e623732f",
    "id": null,
    "metadata": {},
    "name": "WidgetTaskCollectionMockPreviewQuery",
    "operationKind": "query",
    "text": "query WidgetTaskCollectionMockPreviewQuery(\n  $storecastId: ID!\n  $input: PreviewWidgetTaskCollectionInput!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetTaskCollection(input: $input) {\n      ...WidgetTaskCollection_widgetTaskCollection\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetTaskCollection_widgetTaskCollection on WidgetTaskCollection {\n  id\n  title\n  taskSections {\n    __typename\n    id\n    section {\n      id\n      title\n    }\n    task {\n      __typename\n      id\n      title\n      routine {\n        id\n        title\n      }\n    }\n    inProgressTaskExecution {\n      __typename\n      ...WidgetTaskMultipleRenderTask_taskExecution\n      id\n    }\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck on TaskExecutionCheck {\n  checkValue\n}\n\nfragment WidgetTaskMultipleRenderTaskContent_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ... on TaskExecutionCheck {\n    __typename\n    ...WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck\n  }\n  ... on TaskExecutionNumber {\n    __typename\n    ...WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber\n  }\n  ... on TaskExecutionText {\n    __typename\n    ...WidgetTaskMultipleRenderTaskText_taskExecutionText\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber on TaskExecutionNumber {\n  numberValue\n  formattedNumberValue\n}\n\nfragment WidgetTaskMultipleRenderTaskText_taskExecutionText on TaskExecutionText {\n  textValue\n}\n\nfragment WidgetTaskMultipleRenderTask_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ...WidgetTaskMultipleRenderTaskContent_taskExecution\n  routineOccasion {\n    endAt\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2a8fca19952933daa9328c2f0406982";

export default node;
